export interface ProductBrand {
	"@type": "Brand";
	name: string;
}

/**
 * schema.org `brand` for a Product from the Norce manufacturer. `fallbackName`
 * is for single-brand stores only (e.g. the site name) — a multi-brand
 * retailer must not publish itself as every product's brand.
 */
export const buildProductBrand = (
	manufacturerName: string | undefined,
	fallbackName?: string
): ProductBrand | undefined => {
	const name = manufacturerName?.trim() || fallbackName?.trim();
	return name ? { "@type": "Brand", name } : undefined;
};
